import { createPortal } from 'react-dom'
import './Spinner.scss'

interface GlobalLoadingSpinnerProps {
  isLoading: boolean
}

/**
 * Always renders on top of document.body, covering the full viewport.
 */
export const GlobalLoadingSpinner = ({
  isLoading,
}: GlobalLoadingSpinnerProps) => {
  if (!isLoading) return

  return createPortal(
    <div className="loader-wrapper">
      <div className="loader" />
    </div>,
    document.body,
  )
}
